import {ColorRampFilter} from "../../Filters/ColorRampFilter";
import * as PIXI from "pixi.js";
import {texture} from "../../Core/AssetHelpers";
import * as HLF from "html-living-framework";

export class CookingItemColor extends ColorRampFilter {

    private _index = 1;
    private readonly _name: string;
    public readonly maxIndex: number;

    constructor(name: string, ...targets: PIXI.DisplayObject[]) {
        super(texture(name.replace("{i}", "1"))!);
        this._name = name;
        for (const target of targets) {
            target.filters = [this];
        }
        let m = 1;
        while (texture(this._name.replace("{i}", m.toString()))) m++;
        this.maxIndex = m - 1;
    }

    get index() {
        return this._index;
    }

    set index(value) {
        if (value < 0 || !texture(this._name.replace("{i}", value.toString()))) {
            value = 0;
        }
        this._index = value;
        this.ramp = texture(this._name.replace("{i}", value.toString()))!;
    }

    setRandomIndex() {
        this.index = HLF.Random.intBetween(1, this.maxIndex + 1);
    }
}